import type { NotificationStream } from '@/features/notifications/application/port/notification-stream';
import type { Notification } from '@/features/notifications/domain/model/notification';
import { supabase } from '@/shared/infrastructure/supabase/client';

export const supabaseNotificationStream: NotificationStream = {
  subscribe(locationId, { onInserted, onUpdated }) {
    const filter = `location_id=eq.${locationId}`;

    const channel = supabase
      .channel(`notifications:${filter}`)
      .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'notifications', filter }, payload =>
        onInserted(payload.new as Notification)
      )
      .on('postgres_changes', { event: 'UPDATE', schema: 'public', table: 'notifications', filter }, payload =>
        onUpdated(payload.new as Notification)
      )
      .subscribe((status, err) => {
        if (status === 'CHANNEL_ERROR' && err) {
          console.error('Canal de notificaciones en error:', err);
        }
      });

    return () => {
      void supabase.removeChannel(channel);
    };
  },
};
